module.exports = __webpack_public_path__ + "img/9.fb0f4795.png";